import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DateViewComponent} from './components/date-view/date-view.component';
import {DateComponent} from './components/date/date.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
// import {SelectComponent} from './components/select/select.component';
import {FormsModule} from '@angular/forms';
import {ValidationComponent} from './components/validation/validation';
// import {CustomNgbDateParserFormatter} from './class/custom-ngb-date-parser-formatter';
import {SwitchComponent} from './components/switch/switch.component';
// import {InputComponent} from './components/input/input.component';
import {ValidNumbersDirective} from './directives/valid-numbers.directive';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatDatepickerModule,
  MatFormFieldModule,
  MatInputModule,
  MatNativeDateModule
} from '@angular/material';
import {NgxMaskModule} from 'ngx-mask';
import {MaskDateDirective} from 'app/modules/forms/directives/mask-date.directive';
import {APP_DATE_FORMATS, AppDateAdapter} from './class/app-date.adapter';
import {AutocompleteComponent} from './components/autocomplete/autocomplete.component';
import {AutoCompleteService} from './services/auto-complete.service';
import {OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE, OwlDateTimeIntl, OwlDateTimeModule, OwlNativeDateTimeModule} from 'ng-pick-datetime';
import {DateTimeComponent} from './components/datetime/date-time.component';

export class DefaultOwlDateTimeIntl extends OwlDateTimeIntl {
  setBtnLabel = '✔';
  cancelBtnLabel = '✖';
}

export const OWL_CUSTOM_DATE_FORMATS = {
  fullPickerInput: {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'},
  datePickerInput: {year: 'numeric', month: 'numeric', day: 'numeric'},
  timePickerInput: {hour: 'numeric', minute: 'numeric', second: 'numeric'},
  monthYearLabel: {year: 'numeric', month: 'short'},
  dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
  monthYearA11yLabel: {year: 'numeric', month: 'long'},
};

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule.forRoot(),
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMaskModule.forRoot(),
    OwlDateTimeModule,
    OwlNativeDateTimeModule
    // TextMaskModule
  ],
  declarations: [
    ValidationComponent,
    // InputComponent,
    DateViewComponent,
    DateComponent,
    SwitchComponent,
    ValidNumbersDirective,
    MaskDateDirective,
    AutocompleteComponent,
    DateTimeComponent
    // SelectComponent
  ],
  exports: [
    ValidationComponent,
    // InputComponent,
    DateViewComponent,
    DateComponent,
    SwitchComponent,
    // SelectComponent
    ValidNumbersDirective,
    AutocompleteComponent,
    MatInputModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    DateTimeComponent
  ],
  providers: [
    {provide: DateAdapter, useClass: AppDateAdapter, useValue: {useUtc: true}},
    {provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS},
    {provide: MAT_DATE_LOCALE, useValue: 'ru-RU'},
    {provide: OWL_DATE_TIME_LOCALE, useValue: 'ru'},
    {provide: OwlDateTimeIntl, useClass: DefaultOwlDateTimeIntl},
    {provide: OWL_DATE_TIME_FORMATS, useValue: OWL_CUSTOM_DATE_FORMATS},
    AutoCompleteService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppFormsModule {
}



// WEBPACK FOOTER //
// ./src/app/modules/forms/forms.module.ts